/**
 * @prettier
 */

import React, { FunctionComponent, useEffect, useState } from "react";
import { Container, CssBaseline, Grid, Box } from "@material-ui/core";
import { Link } from "@reach/router";
import { fromEvent, Observable } from "rxjs";

import Login from "components/Login";
import { ReactComponent as Logo } from "static/logo.svg";
import { ReactComponent as TR } from "static/media/tr.svg";
import { ReactComponent as BL } from "static/media/bl.svg";
import { ReactComponent as BackArrow } from "static/media/backArrow.svg";
import ForgotPass from "components/ForgotPass";
import { PageType } from "types/PageType";
import { useStyles } from "./styles";
import FormFooter from "./FormFooter";

export const AuthPage: FunctionComponent<PageType> = ({ path }) => {
  const classes = useStyles({});
  const [mobileMenu, switchMobileMenu] = useState(
    !(document.documentElement.offsetWidth > 1000)
  );

  const resize$: Observable<Event> = fromEvent(window, "resize");

  resize$.subscribe((res: any) => {
    if (res && res.currentTarget) {
      switchMobileMenu(!(res.currentTarget.innerWidth > 1000));
    }
  });

  useEffect(() => {
    document.body.classList.add("body-signin");
    document.body.style.overflowY = "scroll";
  }, []);
  return (
    <Container component="main" maxWidth="xs" className={classes.root}>
      <CssBaseline />
      {!mobileMenu && (
        <>
          <Box position="absolute" top={0} right={0}>
            <TR className={classes.tr} />
          </Box>
          <Box position="absolute" bottom={0} left={0}>
            <BL className={classes.bl} />
          </Box>
        </>
      )}
      <div className={classes.paper}>
        <Logo className={classes.logo} />
        <span className={classes.pageHeader}>
          {path === "sign-in" ? (
            <div>
              <span style={{ lineHeight: 1.25 }}>Welcome </span> <br />{" "}
              <span style={{ lineHeight: 1.25 }}>to the Be-Hookd Kit!</span>
            </div>
          ) : (
            ""
          )}
          {path === "sign-up" ? "Create Your Account" : ""}
          {path === "forgot-password" ? "Forgot Password?" : ""}
        </span>
        {path === "sign-in" && <Login />}
        {path === "forgot-password" && <ForgotPass />}
        <Grid container className={classes.linkArea}>
          <Grid item xs={12}>
            <Link
              to={path === "sign-in" ? "/forgot-password" : "/sign-in"}
              className={classes.link}
            >
              {path === "sign-in"
                ? "Forgot your password?"
                : path === "forgot-password" && (
                    <>
                      <BackArrow className={classes.backToLogin} />
                      Back to Login
                    </>
                  )}
            </Link>
          </Grid>
          <Grid item xs={12}>
            <FormFooter path={path} />
          </Grid>
        </Grid>
      </div>
    </Container>
  );
};
